import { collection, query } from "@firebase/firestore";
import { Button, Center } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";
import { useCollection } from "react-firebase-hooks/firestore";
import LetterGlitch from "../../../components/LetterGlitch/LetterGlitch";
import { db } from "../../../firebase";
import { downloadStringAsFile } from "../../../helpers/string.helpers";
import { useIsAdminUser } from "../../../helpers/server.helpers";
import QueryError from "../../../components/QueryError/QueryError";

export const Route = createFileRoute("/(app)/admin/export-comments")({
  component: RouteComponent,
});

function RouteComponent() {
  const [value, loading, error] = useCollection(
    query(collection(db, "comment"))
  );

  const isAdmin = useIsAdminUser();

  function onClick() {
    const data = value?.docs.map((d) => d.data());
    downloadStringAsFile(JSON.stringify(data), "firebase-comments.json");
  }

  if (error) return <QueryError error={error} />;
  if (!isAdmin) return <>Not authorized</>;

  return (
    <div
      style={{
        marginTop: -20,
        position: "relative",
        height: "calc(100vh - 140px)",
      }}
    >
      <div style={{ position: "absolute", width: "100%", height: "100%" }}>
        <LetterGlitch
          glitchSpeed={0}
          centerVignette={false}
          outerVignette={false}
          smooth={false}
        />
      </div>

      <Center style={{ paddingTop: 250 }}>
        <Button
          loading={loading}
          size="xl"
          w={500}
          h={200}
          fz={90}
          variant="gradient"
          onClick={onClick}
        >
          Ladda ner
        </Button>
      </Center>
    </div>
  );
}
